// extracted by mini-css-extract-plugin
module.exports = {"card":"news-card-module--card--2xEDk","cardDate":"news-card-module--card-date--T2eOX"};